import { isUserLoggedIn } from 'apps/user/helpers';

export class LoginWatcher {
  onSuccess = [];

  onError = [];

  resolve() {
    this.onSuccess.forEach(cb => cb());
    this.cleanCallbacks();
  }

  reject() {
    this.onError.forEach(cb => cb());
    this.cleanCallbacks();
  }

  cleanCallbacks() {
    this.onSuccess = [];
    this.onError = [];
  }

  subscribe(getState) {
    const isLoggedIn = isUserLoggedIn(getState().user);

    return new Promise((resolve, reject) => {
      if (isLoggedIn) {
        resolve();
      } else {
        this.onSuccess.push(resolve);
        this.onError.push(reject);
      }
    });
  }
}

// Prevent instance export server side. It would cause unexpected issues if used server side.
const instance = (typeof window !== 'undefined') ? new LoginWatcher() : null;
export default instance;
